import { render, staticRenderFns } from "./myTask.vue?vue&type=template&id=3f911eb4&scoped=true&"
import script from "./myTask.vue?vue&type=script&lang=js&"
export * from "./myTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f911eb4",
  null
  
)

export default component.exports